import { db } from "./firebase";

import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

const getAppCollectionRef = (userId) => collection(db, 'UserApps', userId, 'apps');

class AppDataService {
  addApp = (newApp, userId) => {

    return addDoc(getAppCollectionRef(userId), newApp);
  };

  updateApp = (id, userId, updateApp) => {
    const AppDoc = doc(db, "UserApps", userId, 'apps', id);
    return updateDoc(AppDoc, updateApp);
  };

  deleteApp = (id, userId) => {
    const appDoc = doc(db, "UserApps", userId, 'apps', id);
    return deleteDoc(appDoc);
  };

  getAllApps = (userId) => {
    return getDocs(getAppCollectionRef(userId));
  };

  getBook = (id) => {
    const appDoc = doc(db, "UserApps", id);
    return getDoc(appDoc);
  };
}

export default new AppDataService();